import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund API
 */
class DocumentCategoryApi extends ApiBase {
  /**
   * Check if docment name already exists
   * @param {*} name
   */
  async checkNameExists(name) {
    const encodedName = encodeURIComponent(name);
    const request = {
      headers: this.getHeaders(),
      url: `${this.API_URL}/category?name=${encodedName}`,
      method: 'HEAD',
      validateStatus: function(status) {
        return (
          (status >= 200 && status < 300) || status === 404 || status === 403
        );
      }
    };

    const response = await axios.request(request);

    if (response.status === 200 || response.status === 403) {
      // category name is used, in case of 403 it's not visible to the user
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }

  /**
   * Get categories by template ID
   */
  getCategoriesByTemplateID = async templateID => {
    const request = {
      url: `${this.API_URL}/categories?orphanVisibility=ALL_VISIBLE&status=ACTIVE&templateId=${templateID}`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  };
}

export default new DocumentCategoryApi();
